<div *ngIf="state?.hasShortenedDuration && state?.info && !state.requiresConfirmation" class="alert alert-warning" role="alert">
  <strong>Note:</strong> Only {{state.info.remainingMinutes}} minutes available in this service's schedule.
  Duration has been adjusted automatically.
</div>
<div *ngIf="state?.hasShortenedDuration && state?.info && state.requiresConfirmation" class="alert alert-warning" role="alert">
  <strong>Warning:</strong> Only {{state.info.remainingMinutes}} minutes available ({{state.info.durationPercentage}}% of normal duration).
  <label class="form-check-label pl-0 d-flex mt-2">
    <strong>Confirm shortened duration?</strong>
    <input
      type="checkbox"
      class="ml-2"
      [checked]="confirmed"
      (change)="onConfirmedChange($any($event.target).checked)"
    >
  </label>
</div>
